import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PagePermission, FeaturePermission, PermissionActions } from '@enums';
import { currentUserSelector } from '@selectors/user';
import { userHasPermissions } from '@utils';

export const hasPermissionFeature = (
  page: PagePermission,
  features: FeaturePermission[],
  actions: PermissionActions[]
) => {
  const currentUser = useSelector(currentUserSelector);

  return useMemo(() => {
    if (!currentUser) {
      return false;
    }
    return userHasPermissions(currentUser, page, features, actions);
  }, [page, features, currentUser]);
};
